import { createSlice } from '@reduxjs/toolkit';

const homeSlice = createSlice({
  name: 'home',
  initialState: {
    welcomeText: 'Welcome to Rest Assured Home',
  },
  reducers: {
    updateText: (state, action) => {
      state.welcomeText = action.payload;
    },
  },
});

export const { updateText } = homeSlice.actions;
export default homeSlice.reducer;
